import { create } from "zustand";
import type { IPayoutTransactionMinimal } from "../types/models/payout-transaction.modals.types";

interface IPayoutsStore {
	data: IPayoutTransactionMinimal[];
	setData: (data: IPayoutTransactionMinimal[]) => void;
	removeById: (id: string) => void;
}

const usePayoutsStore = create<IPayoutsStore>((set) => ({
	data: [],
	setData: (data: IPayoutTransactionMinimal[]) => set(() => ({ data })),
	removeById: (id: string) =>
		set((state) => ({
			data: state.data.filter((payout) => payout.id !== id),
		})),
}));

export default usePayoutsStore;
